import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import useAuth from '@components/Hooks/useAuth';
import { Loader } from '@components/index';
import { loginComponent } from '@components/auth/UserLoginActions';
import UserLoginContainer from '@components/auth/UserLoginContainer';

import './EnterpriseLoginContainer.scss';

const LoginComponent = () => {
    const dispatch = useDispatch();

    const navigate = useNavigate();

    const { loading, loggedIn, isEnterprise, isDash } = useAuth();

    React.useEffect(() => {
        if (isDash) return navigate('/enterprise/dashboard');
        if (isEnterprise) return navigate('/enterprise/dealer-dashboard');
        if (loggedIn) return window.location.assign('/account/info');
        return dispatch(loginComponent());
    }, [loggedIn, isEnterprise, isDash, dispatch, navigate]);

    if (loading) return <Loader />;

    return (
        <div className="enterprise-login">
            <div className="container">
                <div className="row">
                    <div className="col-sm-4 offset-sm-4">
                        <UserLoginContainer
                            enterprise={1}
                            social={0}
                            register={0}
                        />
                        <div className="text-center">
                            Mail us to register as Enterprise
                            <br />
                            <a href="mailto:support@orangebookvalue.com">
                                support@orangebookvalue.com
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginComponent;
